import { Address } from 'types';

export const isBillingAddressAvailable = (
  billingAddresses: Address[] | undefined
) => {
  return billingAddresses && billingAddresses.length > 0;
};

export const isValidBillingAddressSelected = (
  selectedBillingAddress: Address | undefined,
  userBillingAddresses: Address[] | undefined
) => {
  return isBillingAddressAvailable(userBillingAddresses)
    ? typeof selectedBillingAddress !== 'undefined'
    : true;
};

export const getNameFromAddress = (address: Address | undefined) => {
  return address && address.countryIso === 'JP'
    ? address.translatedName ?? ''
    : '';
};

export const getMailingNameFromAddress = (address: Address | undefined) => {
  return (
    address &&
    (address.countryIso === 'JP'
      ? address.translatedMailingName ?? ''
      : address.mailingName)
  );
};
